export default function useEventTheme() {
  return {};
}
